import isNil from "lodash/isNil";
import startCase from "lodash/startCase";
import { Col, Grid, Row } from "react-bootstrap";
import Button from "../Button";

import React, { PureComponent } from "react";
import PreLoader from "@wevo/react-components/lib/PreLoader";
import { MuiThemeProvider } from "material-ui-old/styles";
import { greyPalette } from "../../helpers/constants/colorPalettes";
import * as colors from "../../helpers/constants/colors";
import * as wevoConfigurationActions from "../../modules/configure-wevo/actions";
import IconButton from "material-ui-old/IconButton";
import KeyboardArrowLeft from "material-ui-old/svg-icons/hardware/keyboard-arrow-left";
import KeyboardArrowRight from "material-ui-old/svg-icons/hardware/keyboard-arrow-right";
import MobileImageContainer from "../MobileImageContainer";
import ThumbnailGrid from "./ThumbnailGrid";
import keydown, { Keys } from "react-keydown";
import * as wevoConfigurationTypes from "../../modules/configure-wevo/types";
import { pageSelectors } from "../../modules/pages/index";
import { trackerActions } from "../../modules/tracker/index";
import { deviceConstants } from "../../modules/devices/index";
import { connect } from "react-redux";
import { ConfigureProjectEvents } from "../../modules/tracker/event-names/index";
import ScrollLockDiv from "../ScrollLockDiv";
import * as styles from "../../styles/components/PickCTAs.css";
import Truncated from "../Truncated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const { DEVICES, MOBILE } = deviceConstants;
const { LEFT, RIGHT } = Keys;

class PickCTAs extends PureComponent {
    static CTA_SIZE = 20;

    constructor(props) {
        super(props);
        this.selectPage = this.selectPage.bind(this);
    }

    componentWillMount() {
        const state = this.updateStateFromProps(this.props);
        const { loadingStateKey } = this.props;
        this.state = {
            loadingStateKey,
            imagesLoaded: {},
            imageContainers: {},
            ...state
        };
        this.toNextStep = this.props.toNextStep;
    }

    componentDidMount() {
        this.props.trackEvent(ConfigureProjectEvents.DID_NAVIGATE_TO_PICK_CTAS);
    }

    componentWillUpdate(nextProps, nextState) {
        /* Reset Wevo Page Scrolling to Top on Re-Render */
        const { selectedPage } = this.state;
        if (selectedPage && selectedPage.id !== nextState.selectedPage.id) {
            var desktopContainer = document.getElementById("page-container");
            if (desktopContainer) desktopContainer.scrollTop = 0;
        }
    }
    componentWillReceiveProps(nextProps) {
        const newState = this.updateStateFromProps(nextProps);

        this.setState({
            ...this.state,
            ...newState
        });
    }

    updateStateFromProps(props) {
        const { wevo, wevoId, entities, loadingState } = props;
        const sortedAndFilteredPages = PickCTAs.sortAndFilterPages(wevo);
        let selectedPage;
        if (this.state && this.state.selectedPage) {
            selectedPage = pageSelectors.getPageById(
                entities,
                this.state.selectedPage.id
            );
        } else if (!isNil(this.props.selectedPageId)) {
            selectedPage = pageSelectors.getPageById(
                entities,
                this.props.selectedPageId
            );
        }
        if (!selectedPage) {
            selectedPage = sortedAndFilteredPages.find(p => {
                return p.isActive;
            });
        }
        let isLoading = false;
        if (
            loadingState &&
            loadingState[wevoId] &&
            loadingState[wevoId].status &&
            (loadingState[wevoId].status ===
                wevoConfigurationTypes.REQUEST_CREATE_CTA ||
                loadingState[wevoId].status ===
                    wevoConfigurationTypes.REQUEST_REMOVE_CTA)
        ) {
            isLoading = true;
        }
        return {
            ...(this.state || {}),
            wevo,
            wevoId,
            selectedPage,
            pages: sortedAndFilteredPages,
            loadingState,
            isLoading
        };
    }

    static sortAndFilterPages(wevo) {
        return wevo.pages
            .reduce((acc, page) => {
                if (page.isActive) {
                    acc.push(page);
                }
                return acc;
            }, [])
            .sort((a, b) => {
                const sortOrderDiff = a.sortOrder - b.sortOrder;
                if (sortOrderDiff !== 0) {
                    return sortOrderDiff;
                }
                return a.name > b.name ? 1 : -1;
            });
    }

    isValid() {
        const { wevo } = this.state;
        const activePages = wevo.pages.filter(page => {
            return page && page.isActive;
        });
        if (activePages.length === 0) {
            return false;
        }
        return activePages.every(page => {
            if (!page.ctas || page.ctas.length === 0) {
                return false;
            }
            const activeCtas = page.ctas.reduce((count, cta) => {
                if (cta && cta.isActive) {
                    count++;
                }
                return count;
            }, 0);
            return activeCtas > 0;
        });
    }
    selectPage(page) {
        const { selectedPage, isLoading } = this.state;
        if (page.id === selectedPage.id || isLoading) return;
        this.setState({
            ...this.state,
            selectedPage: page
        });
    }

    handleImageLoad(pageId) {
        const { selectedPage } = this.state;
        const imagesLoaded = this.state.imagesLoaded;
        imagesLoaded[pageId] = true;
        const imgElemKey = `image${selectedPage.id}`;
        this.state.imageContainers[imgElemKey] = this.refs[imgElemKey];
        this.state.imagesLoaded[pageId] = true;
        this.forceUpdate();
    }

    removeCta(ctaId, e) {
        e.stopPropagation();
        const { dispatch } = this.props;
        const { wevoId, selectedPage } = this.state;
        const pageId = selectedPage.id;
        if (wevoId && pageId && ctaId) {
            dispatch(wevoConfigurationActions.removeCta(wevoId, pageId, ctaId));
        }
    }

    addCta(originalImage, e) {
        const { dispatch } = this.props;
        const { wevoId, selectedPage } = this.state;
        const pageId = selectedPage.id;
        const { nativeEvent, target } = e;
        const divDimensions = target.getBoundingClientRect();
        const divHeight = divDimensions.height;
        const divWidth = divDimensions.width;
        const { offsetX, offsetY } = nativeEvent;
        const originalWidth = originalImage.width;
        const originalHeight = originalImage.height;
        const x = Math.round((originalWidth * offsetX) / divWidth);
        const y = Math.round((originalHeight * offsetY) / divHeight);
        if (!isNil(wevoId) && !isNil(pageId) && !isNil(x) && !isNil(y)) {
            dispatch(
                wevoConfigurationActions.addCta(wevoId, pageId, {
                    x,
                    y,
                    clickNumber: selectedPage.ctas.length + 1
                })
            );
        }
    }

    navigatePageIndex(increment) {
        const { pages, selectedPage, isLoading } = this.state;
        let selectedIndex = 0;
        pages.some((p, index) => {
            if (p.id === selectedPage.id) {
                selectedIndex = index;
                return true;
            }
            return false;
        });
        const newIndex = selectedIndex + increment;
        if (newIndex >= 0 && newIndex < pages.length && !isLoading) {
            this.selectPage(pages[newIndex]);
        }
    }

    @keydown(LEFT, RIGHT)
    handleArrowNavigation(e) {
        const { isLoading } = this.state;
        if (!isLoading) {
            this.props.trackEvent(
                ConfigureProjectEvents.DID_SWITCH_PAGES_WITH_KEYBOARD
            );
            switch (e.which) {
                case LEFT:
                    this.navigatePageIndex(-1);
                    break;
                case RIGHT:
                    this.navigatePageIndex(1);
                    break;
                default:
                    break;
            }
        }
    }

    /* --------------------------------------------------------
     * Render Functions
     * -------------------------------------------------------- */

    renderArrowButton(direction) {
        const { pages, selectedPage } = this.state;
        const selectedIndex = pages.findIndex(p => p.id === selectedPage.id);

        const DIRECTIONS = {
            left: {
                isDisabled: selectedIndex === 0,
                text: "Last Page",
                increment: -1,
                style: { top: "5px", left: "49px", position: "absolute" },
                arrowIcon: () => {
                    return <KeyboardArrowLeft />;
                }
            },
            right: {
                isDisabled: selectedIndex === pages.length - 1,
                text: "Next Page",
                increment: 1,
                style: { top: "5px", right: "35px", position: "absolute" },
                arrowIcon: () => {
                    return <KeyboardArrowRight />;
                }
            }
        };

        /* Determine Styling */
        const dirInfo = DIRECTIONS[direction];
        const iconColor = dirInfo.isDisabled
            ? greyPalette.medGrey
            : greyPalette.grey;

        /* Build Element */
        return (
            <MuiThemeProvider>
                <div
                    onClick={() => {
                        this.props.trackEvent(
                            ConfigureProjectEvents.DID_SWITCH_PAGES_WITH_ARROW_CLICK
                        );
                        this.navigatePageIndex(dirInfo.increment);
                    }}
                    style={{
                        display: "inline-block",
                        position: "relative",
                        cursor: "pointer"
                    }}
                >
                    <IconButton
                        iconStyle={{
                            height: 50,
                            width: 50,
                            color: iconColor
                        }}
                        style={{
                            height: 60,
                            padding: 5
                        }}
                        disableTouchRipple={true}
                        disabled={dirInfo.isDisabled}
                    >
                        {dirInfo.arrowIcon()}
                    </IconButton>
                    <h5 style={{ ...dirInfo.style, color: iconColor }}>
                        {dirInfo.text}
                    </h5>
                </div>
            </MuiThemeProvider>
        );
    }

    renderButton() {
        const { nextStepText, wevoId } = this.props;
        if (!this.isValid()) {
            return (
                <Button
                    disabled={true}
                    color="disabled"
                    style={{ width: "240px" }}
                >
                    {" "}
                    {nextStepText}
                </Button>
            );
        }
        return (
            <Button
                style={{ width: "240px" }}
                onClick={() => this.toNextStep(wevoId)}
            >
                {nextStepText}
            </Button>
        );
    }

    renderCtas() {
        const { isReadOnly } = this.props;
        const { selectedPage, isLoading } = this.state;
        const { ctas } = selectedPage;
        const { original } = selectedPage.image.files;
        return ctas.reduce((acc, cta) => {
            if (cta && cta.isActive) {
                const elem = this.state.imageContainers[
                    `image${selectedPage.id}`
                ];
                const elemDimensions = elem.getBoundingClientRect();
                const divHeight = elemDimensions.height;
                const divWidth = elemDimensions.width;
                const { id, x, y } = cta;
                const { height, width } = original;
                const displayX = Math.fround(
                    (x / width - PickCTAs.CTA_SIZE / 2 / divWidth) * 100
                ).toFixed(3);
                const displayY = Math.fround(
                    (y / height - PickCTAs.CTA_SIZE / 2 / divHeight) * 100
                ).toFixed(3);
                acc.push(
                    <div
                        key={id}
                        onClick={
                            isLoading || isReadOnly
                                ? () => null
                                : this.removeCta.bind(this, id)
                        }
                        style={{
                            height: `${PickCTAs.CTA_SIZE}px`,
                            width: `${PickCTAs.CTA_SIZE}px`,
                            left: `${displayX}%`,
                            top: `${displayY}%`,
                            borderRadius: `${PickCTAs.CTA_SIZE}px`,
                            backgroundColor: colors.accent,
                            position: "absolute"
                        }}
                    />
                );
            }
            return acc;
        }, []);
    }

    renderPageCaption(device, selectedPage, pages) {
        const selectedIndex =
            pages
                .map(page => {
                    return page.id;
                })
                .indexOf(selectedPage.id) + 1;

        return (
            <Row
                style={{
                    marginLeft: "102px",
                    marginRight: "102px"
                }}
            >
                <div style={{ height: "20px", width: "100%" }}>
                    <h4 className={`pull-left ${styles.pageIndex}`}>
                        <FontAwesomeIcon
                            className={styles.pageIndexIcon}
                            icon={device.icon}
                        />
                        {`${device.label} Pages: ${selectedIndex} of ${
                            pages.length
                        }`}
                    </h4>
                    <Truncated
                        type="h4"
                        maxLength={40}
                        className={`pull-right ${styles.pageCaption}`}
                    >
                        {selectedPage.name}
                    </Truncated>
                </div>
            </Row>
        );
    }

    renderPageViewer(device) {
        const { selectedPage } = this.state;
        const deviceName = device.name;
        return (
            <div
                key={`${deviceName}-${selectedPage.id}`}
                className={`${styles.pageViewer} ${styles[deviceName]}`}
            >
                {this.renderArrowButton("left")}
                <div
                    id="page-container"
                    className={`${styles.pageContainer} ${styles[deviceName]}`}
                >
                    {this.renderSelectedPage()}
                </div>
                {this.renderArrowButton("right")}
            </div>
        );
    }

    renderSelectedPageImage() {
        const { isReadOnly } = this.props;
        const { selectedPage, isLoading } = this.state;
        const { image } = selectedPage;
        const { original } = image.files;
        return (
            <div>
                <div className={styles.selectedImage}>
                    <div
                        className="image-dimmer-overlay"
                        onClick={
                            isLoading || isReadOnly
                                ? () => null
                                : this.addCta.bind(this, original)
                        }
                    />
                    {this.state.imagesLoaded[selectedPage.id]
                        ? this.renderCtas()
                        : ""}
                    <img
                        ref={`image${selectedPage.id}`}
                        src={original.imageUrl}
                        onLoad={this.handleImageLoad.bind(
                            this,
                            selectedPage.id
                        )}
                    />
                </div>
                {isLoading ? (
                    <div className={styles.loadingSelectedImage}>
                        <PreLoader />
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }

    renderSelectedPage() {
        const { selectedPage } = this.state;
        const { deviceId } = selectedPage;
        const scrollLockStyle = {
            width: "100%",
            height: "100%",
            overflow: "scroll"
        };

        if (DEVICES[deviceId].name === MOBILE) {
            return (
                <MobileImageContainer>
                    <ScrollLockDiv style={scrollLockStyle}>
                        {this.renderSelectedPageImage()}
                    </ScrollLockDiv>
                </MobileImageContainer>
            );
        } else {
            return (
                <ScrollLockDiv style={scrollLockStyle}>
                    {this.renderSelectedPageImage()}
                </ScrollLockDiv>
            );
        }
    }

    renderThumbnails() {
        const { pages, selectedPage } = this.state;
        return (
            <div className={styles.thumbnailContainer}>
                <ThumbnailGrid
                    pages={pages}
                    selectedPage={selectedPage}
                    selectPage={this.selectPage}
                    horizontalLayout={true}
                />
            </div>
        );
    }

    render() {
        const { wevo } = this.state;
        if (!wevo || wevo.pages.length === 0) {
            return <PreLoader />;
        }

        const { pages, selectedPage } = this.state;
        const { deviceId } = selectedPage;
        const device = DEVICES[deviceId];
        const labels = this.props.stepLabels;

        return (
            <Grid style={{ width: "100%" }}>
                <Row>
                    <Col xs={6} xsOffset={3}>
                        <h1>{labels.title || labels.leftBar}</h1>
                        <h5>{labels.subtitle || ""}</h5>
                    </Col>
                </Row>
                <div className={styles.contentContainer}>
                    {this.renderPageCaption(device, selectedPage, pages)}
                    {this.renderPageViewer(device)}
                    {this.renderThumbnails()}
                    {this.renderButton()}
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPageId: state.queryString.page
    };
}

function mapDispatchToProps(dispatch) {
    return {
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PickCTAs);



// WEBPACK FOOTER //
// ./src/components/CreateTest/PickCTAs.js